import { Typography } from 'seagull';
import { Checkbox } from 'seagull';
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { jsx as _jsx } from "react/jsx-runtime";
export default function PaymentMethodRequiredCell(_ref) {
  let {
    draft,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref;
  const onClick = () => onOpenModal({
    width: '640px',
    renderContent: _ref2 => {
      let {
        draft,
        setDraft
      } = _ref2;
      return {
        title: 'Allow proposal approval without payment method',
        testid: "edit-payment-method-required-modal-".concat(index),
        content: /*#__PURE__*/_jsx(Checkbox, {
          "data-testid": "edit-payment-method-required-checkbox-".concat(index),
          checked: draft.allowWithoutPaymentMethod(),
          onChange: () => setDraft(draft.setRequirePaymentMethod(draft.allowWithoutPaymentMethod())),
          children: /*#__PURE__*/_jsx(Typography, {
            skin: "standard",
            children: "Let my client approve the agreement without providing a payment method"
          })
        }),
        onSubmit: defaultBehavior => {
          defaultBehavior();
        }
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "payment-method-required-cell-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      "data-testid": "payment-method-required-".concat(index),
      children: draft.allowWithoutPaymentMethod() ? 'Yes' : 'No'
    })
  });
}